import { render, staticRenderFns } from "./ParcelUpload.vue?vue&type=template&id=05e36f1f&"
import script from "./ParcelUpload.vue?vue&type=script&lang=ts&"
export * from "./ParcelUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports